'use strict';

var _ = require('lodash');
var StrategyAllocationAuthAvailActionFactory = function StrategyAllocationAuthAvailActionFactory() {
  function StrategyAllocationAuthAvailAction(className, allocationType, minAllocation, maxAllocation, hardOverrideMinValue, hardOverrideMaxValue, authLinkValue, minAvailability, maxAvailability, linkValue, linkType, hardOverrideType) {
    this.className = className;
    this.allocationType = allocationType;
    this.minAllocation = minAllocation;
    this.maxAllocation = maxAllocation;
    this.hardOverrideMinValue = hardOverrideMinValue;
    this.hardOverrideMaxValue = hardOverrideMaxValue;
    this.authLinkValue = authLinkValue;
    this.minAvailability = minAvailability;
    this.maxAvailability = maxAvailability;
    this.linkValue = linkValue;
    this.linkType = linkType;
    this.hardOverrideType = hardOverrideType;
  }
  StrategyAllocationAuthAvailAction.prototype.isEmpty = function () {
    return (_.isNil(this.allocationType) || this.allocationType === '') && (_.isNil(this.minAllocation) || this.minAllocation === '') && (_.isNil(this.maxAllocation) || this.maxAllocation === '') && (_.isNil(this.hardOverrideMinValue) || this.hardOverrideMinValue === '') && (_.isNil(this.hardOverrideMaxValue) || this.hardOverrideMaxValue === '') && (_.isNil(this.authLinkValue) || this.authLinkValue === '') && (_.isNil(this.minAvailability) || this.minAvailability === '') && (_.isNil(this.maxAvailability) || this.maxAvailability === '') && (_.isNil(this.linkValue) || this.linkValue === '') && (_.isNil(this.linkType) || this.linkType === '') && (_.isNil(this.hardOverrideType) || this.hardOverrideType === '');
  };
  StrategyAllocationAuthAvailAction.prototype.createCopy = function () {
    return new StrategyAllocationAuthAvailAction(this.className, this.allocationType, this.minAllocation, this.maxAllocation, this.hardOverrideMinValue, this.hardOverrideMaxValue, this.authLinkValue, this.minAvailability, this.maxAvailability, this.linkValue, this.linkType, this.hardOverrideType);
  };
  return StrategyAllocationAuthAvailAction;
};
StrategyAllocationAuthAvailActionFactory.$inject = [];
module.exports = StrategyAllocationAuthAvailActionFactory;